@if (hasCreditInformation()) {
<div class="credit-info flex flex-column gap-3">
    <div class="mb-3 flex justify-content-center align-items-center py-2 sara-header-bg border-1 border-round-lg">
        <span class="text-white font-bold">Credit Information</span>
    </div>

    @if (hasInternetCreditDecision()) {
    <ng-container [ngTemplateOutlet]="internetCreditInfo"></ng-container>
    }

    @if (hasVideoCreditDecision()) {
    <ng-container [ngTemplateOutlet]="videoCreditInfo"></ng-container>
    }

    @if (hasWirelessCreditDecision()) {
    <ng-container [ngTemplateOutlet]="wirelessCreditInfo"></ng-container>
    }

    @if (hasVoiceCreditDecision()) {
    <ng-container [ngTemplateOutlet]="voiceCreditInfo"></ng-container>
    }

    @if (showRefresh && hasCreditInformation()) {
    <div class="credit-info__footer pt-3 flex justify-content-center">
        <p-button icon="pi pi-refresh" label="REFRESH CREDIT INFO" [link]="true"
            styleClass="credit-info__refresh font-bold p-0" (onClick)="onRefreshCreditInfo()"></p-button>
    </div>
    }
</div>
}

<ng-template #internetCreditInfo>
    <section class="flex flex-column gap-2">
        @let decision = internetCreditDetails();
        <ng-container [ngTemplateOutlet]="sectionHeader"
            [ngTemplateOutletContext]="{ title: 'Internet' }"></ng-container>
        <ng-container [ngTemplateOutlet]="creditDetails"
            [ngTemplateOutletContext]="{ orderNumber: decision.orderNumber, accountNumber: decision.accountNumber }"></ng-container>

        @if (decision.creditClass) {
        <div class="credit-info__risk font-semibold text-primary">{{decision.creditClass}} Risk</div>
        }
    </section>
</ng-template>

<ng-template #videoCreditInfo>
    <section class="flex flex-column gap-2">
        @let decision = videoCreditDecision();
        <ng-container [ngTemplateOutlet]="sectionHeader" [ngTemplateOutletContext]="{ title: 'Video' }"></ng-container>
        <ng-container [ngTemplateOutlet]="creditDetails"
            [ngTemplateOutletContext]="{ orderNumber: decision.orderNumber, accountNumber: decision.accountNumber }"></ng-container>

        @if (decision.creditClass) {
        <div class="credit-info__risk font-semibold text-primary">{{decision.creditClass}} Risk</div>
        }
    </section>
</ng-template>

<ng-template #wirelessCreditInfo>
    <section class="flex flex-column gap-2">
        @let decision = wirelessCreditDecision();
        <ng-container [ngTemplateOutlet]="sectionHeader"
            [ngTemplateOutletContext]="{ title: 'Wireless' }"></ng-container>
        <ng-container [ngTemplateOutlet]="creditDetails"
            [ngTemplateOutletContext]="{ orderNumber: decision.orderNumber, accountNumber: decision.accountNumber }"></ng-container>
        @if (decision.fanNumber) {
        <div class="credit-info__detail">
            <span class="font-bold">Fan #:</span>
            <span>{{decision.fanNumber}}</span>
        </div>
        }
        @if (decision.sigfanDiscounType) {
        <div class="credit-info__detail">
            <span class="font-bold">Sigfan Discount Type:</span>
            <span>{{decision.sigfanDiscounType}}</span>
        </div>
        }

        @if(decision.linesApproved) {
        <div class="credit-info__detail">
            <span>You have been approved for {{decision.linesApproved}} lines.</span>
        </div>
        }
        @if(decision.message){
        <div class="credit-info__messages flex flex-column align-items-center text-center mt-2">
            <span [innerHTML]="decision.message || ''"></span>
        </div>
        }
    </section>
</ng-template>

<ng-template #voiceCreditInfo>
    <section class="flex flex-column gap-2">
        @let decision = voiceCreditDecision();
        <ng-container [ngTemplateOutlet]="sectionHeader"
            [ngTemplateOutletContext]="{ title: 'Voice' }"></ng-container>
        <ng-container [ngTemplateOutlet]="creditDetails"
            [ngTemplateOutletContext]="{ orderNumber: decision.orderNumber, accountNumber: decision.accountNumber }"></ng-container>

        @if (decision.creditClass) {
        <div class="credit-info__risk font-semibold text-primary">{{decision.creditClass}} Risk</div>
        }
    </section>
</ng-template>

<ng-template #sectionHeader let-title="title">
    <div class="flex align-items-center justify-content-center">
        <div class="credit-info__section-line flex-1"></div>
        <h2 class="credit-info__section-title font-bold m-0 px-3 white-space-nowrap">{{title}}</h2>
        <div class="credit-info__section-line flex-1"></div>
    </div>
</ng-template>

<ng-template #creditDetails let-orderNumber="orderNumber" let-accountNumber="accountNumber">
    @if (orderNumber) {
    <div class="credit-info__detail">
        <span class="font-bold">Order #:</span>
        <span>{{orderNumber}}</span>
    </div>
    }

    @if (accountNumber) {
    <div class="credit-info__detail">
        <span class="font-bold">Account #:</span>
        <span>{{accountNumber}}</span>
    </div>
    }
</ng-template>